import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'
import { HttpService } from '@ui-components/services';
import { IResponse, IRole } from '@interfaces/index';

@Injectable({
  providedIn: 'root',
})
export class RoleService {

  constructor(
    protected _http_service: HttpService
  ) { }

  getRoles(org_id: number): Observable<IResponse<IRole[]>> {
    return this._http_service.post('roles/get-all', {
      org_id: org_id
    });
  };
}